// extracted by mini-css-extract-plugin
export default {"mainWrapper":"StoreThemeLayout_mainWrapper__EiB-j","contentArea":"StoreThemeLayout_contentArea__uwrNc"};